import { useContent } from '@/content'
import { Section, Surface } from '@/components/ui'
import styles from './SocialPanels.module.css'

/**
 * The social row above the footer. The live site renders these as four full
 * panels with plain text labels — not icon buttons.
 */
export const SocialPanels = () => {
  const { socialLinks: SOCIAL_LINKS } = useContent()

  return (
  <Section spacious aria-label="Social profiles">
    <ul className={styles.row}>
      {SOCIAL_LINKS.map((link) => (
        <li key={link.label}>
          <Surface
            as="a"
            href={link.href}
            target="_blank"
            rel="noreferrer noopener"
            interactive
            className={`t-16 ${styles.panel}`}
          >
            {link.label}
          </Surface>
        </li>
      ))}
    </ul>
  </Section>
  )
}
